"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactRedux = require("react-redux");

var _index = require("../../../../utils/forms/index");

var _radio = _interopRequireDefault(require("./radio"));

var _radio_definition = _interopRequireDefault(require("./radio_definition"));

var _definecomponent = require("../../../../utils/definecomponent");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
// actions
// component
// definition

/* ========== ~~~~~~~~~~ FORM FIELD : CONTAINER ~~~~~~~~~~ ========== */
// map actions


var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setFormFieldValue: function setFormFieldValue(formName, fieldName, value) {
      return dispatch((0, _index.setFormFieldValue)(formName, fieldName, value));
    },
    setFormEditableState: function setFormEditableState(formName, isEditable) {
      return dispatch((0, _index.setFormEditableState)(formName, isEditable));
    },
    setFieldValidation: function setFieldValidation(formName, fieldName, validationStatus) {
      return dispatch((0, _index.setFieldValidation)(formName, fieldName, validationStatus));
    }
  };
};

var ConnectedRadioField = (0, _reactRedux.connect)(null, mapDispatchToProps)(_radio.default);
/* ========== ~~~~~~~~~~ DEFINE COMPONENT ~~~~~~~~~~ ========== */

(0, _definecomponent.defineComponent)(ConnectedRadioField, _radio_definition.default, false);
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

var _default = ConnectedRadioField;
exports.default = _default;